"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigInteger = void 0;
const tslib_1 = require("tslib");
const BigInteger_1 = tslib_1.__importDefault(require("./BigInteger"));
exports.BigInteger = BigInteger_1.default;
